import React, { createContext, useContext, useState } from 'react'

export const DEFAULT_JOB_SEARCH_CRITERIA = {
    is_request_form: null, company: [], color: [], category: [], address: '', name: '',
    city: '', number: NaN, status: [], supervisor: [], asc: false, is_central_texas: false, job_type: []
}

const JobSearchCriteriaContext = createContext()
const useJobSearchCriteriaContext = () => useContext(JobSearchCriteriaContext)

const useContextValue = () => {
    const [contextSearchCriteria, setContextSearchCriteria] = useState(DEFAULT_JOB_SEARCH_CRITERIA)
    const [noMoreDataForCurrentCriteria, setNoMoreDataForCurrentCriteria] = useState(false)
    const [hasUpdatedCriteria, sethasUpdatedCriteria] = useState(false)

    return {
        contextSearchCriteria,
        setContextSearchCriteria,
        noMoreDataForCurrentCriteria,
        setNoMoreDataForCurrentCriteria,
        hasUpdatedCriteria,
        sethasUpdatedCriteria
    }
}


export const JobSearchCriteriaProvider = ({ children }) => {
    const ctx = useContextValue()
    return (
        <JobSearchCriteriaContext.Provider value={ctx}>
            { children}
        </JobSearchCriteriaContext.Provider>
    )
}

export const useJobSearchCriteria = () => {
    const {
        contextSearchCriteria, setContextSearchCriteria,
        noMoreDataForCurrentCriteria, hasUpdatedCriteria,
        setNoMoreDataForCurrentCriteria, sethasUpdatedCriteria
    } = useJobSearchCriteriaContext()

    const getMappedSearchCriteria = (forMap) => {
        return mapSearchCriteria(contextSearchCriteria, forMap)
    }

    const getMappedInternalSearchCriteria = (forMap, internalSearchCriteria) => {
        return mapSearchCriteria(internalSearchCriteria, forMap)
    }

    const resetContextSearchCriteria = () => {
        setContextSearchCriteria(DEFAULT_JOB_SEARCH_CRITERIA)
    }

    const _setContextSearchCriteria = (criteria) => {
        setContextSearchCriteria(criteria)
        setNoMoreDataForCurrentCriteria(false)
        sethasUpdatedCriteria(true)
    }

    return {
        contextSearchCriteria,
        setContextSearchCriteria: _setContextSearchCriteria,
        getMappedSearchCriteria,
        getMappedInternalSearchCriteria,
        resetContextSearchCriteria,
        hasUpdatedCriteria,
        noMoreDataForCurrentCriteria,
        setNoMoreDataForCurrentCriteria,
        sethasUpdatedCriteria
    }
}

const mapMultiSelectValues = (valuesList) => valuesList.map(v => ({ id: v.id }))

const mapSupervisorOptions = (valuesList) => Array.from(new Set(valuesList.filter(v => v).map(v => v.id.toString().split('-h')[0]))).map(i => ({id: i}))

const mapSearchCriteria = (criteria, forMap = false) => ({
    ...criteria,
    company: mapMultiSelectValues(criteria.company),
    color: mapMultiSelectValues(criteria.color),
    category: mapMultiSelectValues(criteria.category),
    supervisor: mapSupervisorOptions(criteria.supervisor),
    status: mapMultiSelectValues(criteria.status),
    job_type: mapMultiSelectValues(criteria.job_type),
    forMap
})
